import { render, staticRenderFns } from "./StatPage.vue?vue&type=template&id=1f535df2&scoped=true"
import script from "./StatPage.vue?vue&type=script&lang=js"
export * from "./StatPage.vue?vue&type=script&lang=js"
import style0 from "./StatPage.vue?vue&type=style&index=0&id=1f535df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f535df2",
  null
  
)

export default component.exports